import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute('/_authenticated/org/$orgId/talents')({
  component: TalentsLayout,
})

function TalentsLayout() {
  return <FeatureGate feature='image' />
}
